// The language is part of the URL: French at the root, English under /en. One URL per language is
// what lets search engines index both, and what hreflang points at.
export type Locale = "fr" | "en";
export const LOCALES: Locale[] = ["fr", "en"];
export const DEFAULT_LOCALE: Locale = "fr";

/** "/connectera" → "/connectera" (fr) or "/en/connectera" (en); "/" → "/" or "/en". */
export function localePath(basePath: string, lang: Locale): string {
  if (lang === DEFAULT_LOCALE) return basePath;
  return basePath === "/" ? `/${lang}` : `/${lang}${basePath}`;
}

/** The language a URL path is in. */
export function localeFromPath(path: string): Locale {
  return path === "/en" || path.startsWith("/en/") ? "en" : DEFAULT_LOCALE;
}

/** "/en/connectera" → "/connectera"; "/en" → "/". */
export function basePathOf(path: string): string {
  if (localeFromPath(path) === DEFAULT_LOCALE) return path;
  const rest = path.slice(3);
  return rest === "" ? "/" : rest;
}
